var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeepeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1172 45.3254C42.2464 43.6353 43.3391 41.9791 44.4683 40.2891C45.3789 41.9791 46.2531 43.6353 47.1637 45.3254C45.1603 45.3254 43.157 45.3254 41.1172 45.3254Z",
    fill: "#9E04D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9111 44.903C8.76226 43.8849 7.86112 41.3734 8.9009 39.2692L23.2497 9.94629C24.2895 7.8421 26.8543 6.95969 29.0031 7.97785C31.152 8.99601 32.0531 11.5075 31.0134 13.6117L16.6645 42.9685C15.6247 45.0388 13.06 45.9212 10.9111 44.903Z",
    fill: "url(#paint0_linear_1045_5883)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8275 44.9298C20.8407 43.9681 19.9844 41.5638 20.9778 39.5717L29.884 21.1617C30.8431 19.1696 33.2409 18.3109 35.2277 19.307C37.2145 20.2687 38.0709 22.673 37.0775 24.6651L28.1712 43.0751C27.2121 45.0672 24.8143 45.8915 22.8275 44.9298Z",
    fill: "url(#paint1_linear_1045_5883)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6894 44.9539C31.7535 44.0463 30.8892 41.794 31.8226 39.8778L34.8648 33.6588C35.7982 31.7762 38.1144 30.9358 40.0849 31.8435C42.0209 32.7511 42.8851 35.0034 41.9517 36.9196L38.9095 43.1386C37.9761 45.0548 35.6254 45.8616 33.6894 44.9539Z",
    fill: "url(#paint2_linear_1045_5883)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1045_5883",
    x1: 10.2628,
    y1: 45.526,
    x2: 28.4299,
    y2: 8.19235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13AAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DDA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1045_5883",
    x1: 23.0721,
    y1: 43.9951,
    x2: 35.0544,
    y2: 20.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1849,
    stopColor: "#F79239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4154,
    stopColor: "#F28849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EC7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#E26185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05B8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1045_5883",
    x1: 33.8165,
    y1: 44.4876,
    x2: 39.6956,
    y2: 32.1905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2727,
    stopColor: "#ED1E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#DF198E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9866,
    stopColor: "#C911A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C811A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeepeeIcon);
export default __webpack_public_path__ + "static/media/teepee-icon.77c2cbe5cd231801494656f4460f59fb.svg";
export { ForwardRef as ReactComponent };